'use strict';
const angular = require('angular');

export class webaccessResetPasswordComponent {
  /*@ngInject*/
  constructor(WebAccessService) {
  }

  $onInit = function () {
    //this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.password});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }
}

export default angular.module('conduu.webaccessResetPassword', [])
  .component('webaccessResetPassword', {
    template: require('./webaccess-reset-password.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: webaccessResetPasswordComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/webaccess-reset-password/webaccess-reset-password.component.js